import React from "react";
import LoginForm from "../Components/LoginForm/LoginForm";

const Login = () => {
  return (
    <LoginForm
      cardName="Sign In"
      isSignUp={false}
      cardStyle=""
    ></LoginForm>
  );
};

export default Login;
